import { ITelemetryItem } from '@microsoft/applicationinsights-web';

const SOURCE = 'Maintenance Frontend';

/**
 * Stamps every telemetry item (exceptions, events, metrics, and
 * auto-collected page views/dependencies) with `source` and `screen`
 * custom properties, so telemetry from this app - and the page it came
 * from - can be identified in Application Insights when multiple apps
 * share the same connection string.
 */
export const addSourceProperty = (item: ITelemetryItem): boolean | void => {
  item.data = {
    ...item.data,
    source: SOURCE,
    screen: window.location.pathname,
  };
  return true;
};
